import React from "react";

const BuyNodeButton = ({ openBuyNodeModal }) => {
  return (
    <button
      type="button"
      onClick={openBuyNodeModal}
      className="z-50 px-5 py-3 w-full sm:w-fit rounded-lg border border-white text-white transition-all duration-300 font-normal text-sm leading-[21px] hover:!bg-[#8C96FF] active:!bg-[#1E31FF] active:translate-x-[1px] active:translate-y-[1px] bg-deepBlue shadow-swapButton"
    >
      Buy a Node
    </button>
  );
};

export default BuyNodeButton;
